import { useTranslation } from 'react-i18next';
import { AppLanguage } from '@anytag/shared-types';
import { localizedDateFormatter } from '@anytag/shared-utils';
import {
  MarketplacePostHistory,
  useMarketplacePostHistoryQuery,
  MarketplaceCampaignPostHistoryStatus
} from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export interface HistoryTemplateProps {
  className?: string;
}

export const HistoryTemplate = ({ className }: HistoryTemplateProps) => {
  const { t, i18n } = useTranslation();
  const { selectedPostId } = usePostModalContext();
  const { data, loading } = useMarketplacePostHistoryQuery({
    skip: !selectedPostId,
    fetchPolicy: 'cache-and-network',
    variables: { pk: Number(selectedPostId) }
  });

  const historyData = data?.marketplacePostHistory;

  const getHistoryPostDetailsText = (post: MarketplacePostHistory) => {
    switch (post.status) {
      case MarketplaceCampaignPostHistoryStatus.APPROVED:
        return t('username approved the post', { username: post.operatedUserName });
      case MarketplaceCampaignPostHistoryStatus.REJECTED:
        return (
          <>
            <p className="text-error">
              {post.reason
                ? t('username rejected the post', { username: post.operatedUserName, reason: post.reason })
                : t('username rejected the post without a reason', { username: post.operatedUserName })}
            </p>
            <p className="text-sm break-all text-black-60">{post.detailedReason}</p>
          </>
        );
      case MarketplaceCampaignPostHistoryStatus.CREATED:
        return t('The creator published the post');
      default:
        return '';
    }
  };

  return (
    <PostModal.HistoryTemplate loading={loading} className={className} data={historyData}>
      {(data) =>
        data.map((post, index) => (
          <div key={index} className="box-border flex w-full items-center border-b-border px-6 py-4">
            <div className="color-black-90 w-23.75 flex-none text-sm">
              {localizedDateFormatter(post.operatedDate, 'PPP', i18n.language as AppLanguage)}
            </div>
            <div className="flex-1 text-base font-semibold">{getHistoryPostDetailsText(post)}</div>
          </div>
        ))
      }
    </PostModal.HistoryTemplate>
  );
};
